import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AppConfig } from '../config/app.config';
import { SELECTED_BUSINESS_STORAGE_KEY } from '../constants/business-storage.constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly loginUrl = `${AppConfig.apiBaseUrl}api/auth/login`;

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url === this.loginUrl) {
      return next.handle(req);
    }

    const token = this.authService.getToken();
    if (!token) {
      return next.handle(req);
    }

    let headers = req.headers.set('Authorization', `Bearer ${token}`);

    if (AppConfig.multiBusiness?.enabled) {
      const businessId = this.readSelectedBusinessId();
      if (businessId) {
        const headerName = AppConfig.multiBusiness.businessIdHeaderName || 'X-Business-Id';
        headers = headers.set(headerName, String(businessId));
      }
    }

    return next.handle(req.clone({ headers })).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.logout();
        }
        return throwError(() => error);
      })
    );
  }

  private readSelectedBusinessId(): number | null {
    const raw =
      localStorage.getItem(SELECTED_BUSINESS_STORAGE_KEY) ??
      sessionStorage.getItem(SELECTED_BUSINESS_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    try {
      const ctx = JSON.parse(raw) as { businessId?: number };
      return ctx?.businessId ?? null;
    } catch {
      return null;
    }
  }
}
